export * from './space-details.component';
